<template>
  <div class="collection-page">
    <div v-if="fetching" class="lead text-muted container loading"><i class="fa fa-circle-o-notch fa-spin"/> Loading...</div>
    <div v-if="!fetching && fetchError" class="container">
      <h1>We couldn't find this page</h1>
      <p class="lead">Contact support with how you got here, along with the message below:</p>
      <div class="alert alert-danger">{{ fetchError }}</div>
      <p class="lead"><router-link to="Home">Return to Goalbook Toolkit</router-link></p>
    </div>
    <CopyTrackWrapper
      v-if="collection"
      type="curated_collection"
      :title="collection.name"
      :uuid="id"
      :enforce-quota="false">
      <CollectionDetail
        :id="collection.uuid"
        :name="collection.name"
        :description="collection.desc"
        :image-url="collection.image_url"
        :content="collection.content" />
    </CopyTrackWrapper>

    <div class="container">
      <SubmitFeedback
        v-if="collection"
        :uuid="id"
        :title="collection.name"
        type="Curated Collection"/>
    </div>
  </div>
</template>

<script>
import CollectionDetail from './CollectionDetail'
import SubmitFeedback from '@/components/SubmitFeedback'
import CopyTrackWrapper from '@/components/CopyTrackWrapper'
import { getCuratedCollection } from '@/api/pathways'
import { setTitle } from '@/util/title'
import { mapGetters } from 'vuex'

export default {
  name: 'CollectionPage',
  components: { CollectionDetail, SubmitFeedback, CopyTrackWrapper },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      fetching: false,
      fetchError: '',
      collection: null
    }
  },
  computed: {
    ...mapGetters('user', ['userId'])
  },
  methods: {
    async fetch() {
      this.fetching = true
      this.fetchError = ''

      try {
        let resp = await getCuratedCollection(this.id, this.userId)
        this.collection = resp.collection
        this.fetching = false
        setTitle(this.collection.name)
      } catch (err) {
        this.fetching = false
        this.fetchError = err.responseText
      }
    }
  },
  eventContext() {
    if (!this.collection) {
      return {}
    }
    return {
      curated_collection_uuid: this.collection.uuid,
      curated_collection_name: this.collection.name
    }
  },
  async created() {
    await this.fetch()
    this.$sendEvent('Viewed Curated Collection')
  }
}
</script>

<style lang="less" scoped>
.collection-page {
  margin-top: -20px; // cover up margin that is beneath the global navbar

  .loading {
    padding-top: 20px;
  }
}
</style>
